import Alpine from 'alpinejs';
import { VideoDownload } from './video_download';

Alpine.data('videoDownload', () => new VideoDownload());
